import BigCalendarScheduler from './BigCalendarScheduler'

const TodoCalendarRemainder = () => {
  return (
    <div>
      <BigCalendarScheduler />
    </div>
  )
}
export default TodoCalendarRemainder
